export function getApiUrl(path: string, apiUrl: string): string {
  const { href } = new URL(path, apiUrl);
  return href;
}
